import { Box, Checkbox, FormControlLabel, Grid, TextField, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getHealthClientAndPalikaInfoData } from "../../../action/HealthClientInfo";
import AHMIS, { API_URL } from "../../../api/api";
import AddAlertMessage from "../../../components/alert/Alert";
import CustomReactSelect from "../../../components/custom-react-select/CustomReactSelect";
import DeleteRegisterRecordConformation from "../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation";
import InputGroupComponent from "../../../components/input-group-component/InputGroupComponent";
import CustomModal from "../../../components/modal/CustomModal";
import NepaliCalender from "../../../components/nepali-calender";
import RegisterHeader from "../../../components/register-header/RegisterHeader";
import { AppMisc } from "../../../misc/appMisc";
import { CASTE_CODES, ERROR, GENDER_OPTIONS, GREATER_THAN_ZERO, MUL_DARTA_SEWA_TYPES, PATIENT_TYPES, REQUIRED_FIELD, ROW_PER_PAGE, SOMETHING_WENT_WRONG, SUCCESS, YEAR } from "../../../utils/constants";
import { AGE_UNITS, MUL_DARTA_NUMBERS_LIST, NEW_PATIENT, PREVIOUS_PATIENT } from "../../../utils/constants/forms";
import { DateUtils } from "../../../utils/dateUtils";
import { SessionStorage } from "../../../utils/storage/sessionStorage";
import MulDartaaRegister from "../components/register/muldartaa-register/MulDartaaRegister";

const MulDartaa = () => {
  const [modalTitle, setModalTitle] = useState("मूल दर्ता रजिस्टरमा नयाँ रेकर्ड थप्नुहोस् ।");
  const [showMulDartaaModal, setShowMulDartaaModal] = useState(false);
  const [palikaOptions, setPalikaOptions] = useState([]);
  const [modalDefaultValues, setModalDefaultValues] = useState();
  const [mulDartaaTableData, setMulDartaaTableData] = useState([]);
  const districtOptions = AppMisc.getDistrictOptions();
  const [showMulDartaaDeleteModal, setShowMulDartaaDeleteModal] = useState(false);
  const [totalSize, setTotalSize] = useState(0);
  const [mulDartaaDeleteId, setMulDartaaDeleteId] = useState(null);
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch, control } = useForm({ defaultValues: { ageUnit: YEAR, cost: "नि:शुल्क" }, });
  const [mulDartaaOptions, setMulDartaaOptions] = useState();
  const [mulDartaaNumberDefaultValues, setMulDartaaNumberDefaultValues] = useState();
  const [districtName, setDistrictName] = useState(null);
  const [palikaName, setPalikaName] = useState(null);
  const [gaunOrTole, setGaunOrTole] = useState([]);
  const dispatch = useDispatch();
  const palikaInfo = useSelector(state => state.healthClientInfo);
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);

  const watchFields = watch(["patientType", "dartaaMiti", "dartaaNumber", "sewaType", "age", "ageUnit"])

  // useEffect(() => {
  //   if (showMulDartaaModal) {
  //     reset()
  //   }
  // }, [showMulDartaaModal, reset])

  useEffect(() => {
    if (showMulDartaaModal) {
      register("district", { required: true });
      register("palikaName", { required: true });
      register("gender", { required: true });
      register("casteCode", { required: true });
      register("age", { required: true });
      register("ageUnit", { required: true });
      register("sewaType", { required: true });
      register("patientType", { required: true });
      register("dateOfBirth");
      register("dartaaMiti", { required: true });
      register("gaunOrTole", { required: true });
      register("otherCountry")
    }
  }, [register, showMulDartaaModal]);


  useEffect(() => {
    if (mulDartaaNumberDefaultValues) {
      setValue("dartaaNumber", mulDartaaNumberDefaultValues.dartaaNumber);
      setValue("patientFirstName", mulDartaaNumberDefaultValues.patientFirstName);
      setValue("patientLastName", mulDartaaNumberDefaultValues.patientLastName);
      if (!mulDartaaNumberDefaultValues.dateOfBirth) {
        setValue("age", mulDartaaNumberDefaultValues.age);
        setValue("ageUnit", mulDartaaNumberDefaultValues.ageUnit);
      }
      setValue("wardNumber", mulDartaaNumberDefaultValues.wardNumber);
      setValue("gaunOrTole", mulDartaaNumberDefaultValues.gaunOrTole);
      setValue("phoneNumber", mulDartaaNumberDefaultValues.phoneNumber);
      setValue("sentFromOrganizationName", mulDartaaNumberDefaultValues.sentFromOrganizationName);
      setValue("casteCode", mulDartaaNumberDefaultValues.casteCode);
      setValue("gender", mulDartaaNumberDefaultValues?.gender);
      setValue("dateOfBirth", mulDartaaNumberDefaultValues.dateOfBirth);
      setValue("parentFullName", mulDartaaNumberDefaultValues.parentFullName)
      setValue("age", mulDartaaNumberDefaultValues?.age)
      setValue("otherCountry", mulDartaaNumberDefaultValues?.otherCountry)
      setValue("nid", mulDartaaNumberDefaultValues?.nid)
      setValue("mulDartaaNumber", mulDartaaNumberDefaultValues.mulDartaaNumber)
      setModalDefaultValues(prev => ({
        ...prev,
        casteCode: mulDartaaNumberDefaultValues.casteCode,
        ageUnit: mulDartaaNumberDefaultValues.ageUnit,
        gender: mulDartaaNumberDefaultValues.gender,
        district: mulDartaaNumberDefaultValues.district,
        palikaName: AppMisc.getMunicipalityName(mulDartaaNumberDefaultValues.palikaName),
      }));
    }
  }, [mulDartaaNumberDefaultValues])

  const openMulDartaaModal = () => {
    setShowMulDartaaModal(true)
  }

  useEffect(() => {
    if (watchFields[0] === NEW_PATIENT && !modalDefaultValues?.id) {
      getDartaaNumber();
    }
  }, [watchFields[0]])

  const closeMulDartaaModal = () => {
    reset({
      patientFirstName: "",
      patientLastName: "",
      gender: "",
      age: "",
      ageUnit: YEAR,
      casteCode: "",
      district: "",
      palikaName: "",
      wardNumber: "",
      gaunOrTole: "",
      nid: "",
      phoneNumber: "",
      sewaType: "",
      otherSewaType: "",
      cost: "नि:शुल्क",
      referredIn: "",
      otherCountry: "",
      mulDartaaNumber: "",
    });
    setShowMulDartaaModal(false)
    setModalDefaultValues({});
  }

  const handlePalikaNameChange = (name, value) => {
    setPalikaName(value);
    setValue(name, value);
  };

  const handleDistrictChange = (name, value, districtOption) => {
    setDistrictName(value);
    setValue(name, value);
    setPalikaOptions(districtOption?.palikas);
    setValue("palikaName", null);
    setValue(name, value);
    districtOption && setPalikaOptions(districtOption.palikas || []);
  };

  const handleCustomReactSelectChange = (name, value) => {
    setValue(name, value);
  };

  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  }

  const submitMulDartaaForm = (data) => {
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
      data.fiscalYear = DateUtils.getFiscalYearFromDateMilli(data.dartaaMiti);
    }
    if (data.patientType === PREVIOUS_PATIENT) {
      data.patientId = mulDartaaNumberDefaultValues?.patientId ? mulDartaaNumberDefaultValues.patientId : '';
    }
    AHMIS.post(API_URL.mulDartaaRegister, data)
      .then(response => {
        if (response.data.type === SUCCESS) {
          closeMulDartaaModal();
          getMulDartaaData(fromDate, toDate)
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  useEffect(() => {
    if (fromDate && toDate) {
      getMulDartaaData(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams, rowsPerPage, pageNumber])

  const getMulDartaaData = (fromDate, toDate, searchParams, healthClientId, pageFromParam) => {
    let url = `${API_URL.mulDartaaRegister}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageFromParam || pageNumber}&rowSize=${rowsPerPage}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        setMulDartaaTableData(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.size)
      })
      .catch(error => {
        AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
      });
  }

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    getMulDartaaData(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const mulDartaaEdit = async (id) => {
    try {
      const response = await AHMIS.get(API_URL.mulDartaaRegister + "/" + id);
      const data = response.data?.data;
      setModalDefaultValues(data);
      response.data.palikaName = data?.palikaName && AppMisc.getMunicipalityName(data.palikaName);
      setShowMulDartaaModal(true);
      // Set form values dynamically using setValue
      Object.keys(data).forEach(key => {
        setValue(key, data[key]);
      });

    } catch (error) {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
    }
  };


  const populateDistrictAndPalikaName = (district, palika, wardNumber) => {
    if (district && palika) {
      let districtObject = districtOptions.find(
        (obj) => obj.value === district
      );
      handleDistrictChange("district", district, districtObject);
      handlePalikaChange("palikaName", palika);
    }
    if (wardNumber) {
      setValue("wardNumber", wardNumber)
    }
  };

  useEffect(() => {
    populateDistrictAndPalikaName(palikaInfo?.district, palikaInfo?.palikaName, palikaInfo?.wardNumber)
  }, [palikaInfo])


  const handlePalikaChange = (name, value) => {
    setPalikaName(value);
    setValue(name, value);
  };

  const closeMulDartaaDeleteModal = () => {
    setShowMulDartaaDeleteModal(false);
    setMulDartaaDeleteId(null);
  }

  const onDeleteMulDartaaRow = (id) => {
    setShowMulDartaaDeleteModal(true);
    setMulDartaaDeleteId(id);
  }

  const deleteMulDartaaRow = (data) => {
    AHMIS.delete(API_URL.mulDartaaRegister + "/" + mulDartaaDeleteId + "?deletedReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowMulDartaaDeleteModal(false);
          setMulDartaaDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          getMulDartaaData(fromDate, toDate)
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const attachMulDartaaOptions = () => {
    let mulDartaaOptions = [];
    AHMIS.get(API_URL.mulDartaaNumber + "?fiscalYear=" + DateUtils.getCurrentFiscalYear())
      .then(response => {
        let data = response.data;
        SessionStorage.setItem(MUL_DARTA_NUMBERS_LIST, data);
        data.forEach(item => {
          mulDartaaOptions.push({ "value": item.mulDartaaNumber, "label": item.mulDartaaNumber + " (" + item.patientFirstName + " " + item.patientLastName + ")", id: item.id });
        });
        setMulDartaaOptions(mulDartaaOptions);
      })
  }

  useEffect(() => {
    attachMulDartaaOptions();
    getGaunOrTole();
  }, [])

  const handleDartaaNumberChange = (name, value, options) => {
    if (value && !modalDefaultValues?.id) {
      let mulDartaaNumbers = SessionStorage.getItem(MUL_DARTA_NUMBERS_LIST);
      if (mulDartaaNumbers) {
        let muldartaaNumberInfo = mulDartaaNumbers.find(obj => obj.mulDartaaNumber === value);
        muldartaaNumberInfo ? setMulDartaaNumberDefaultValues(muldartaaNumberInfo) : getDetailsByMulDartaaNumber(options.id);
      } else {
        getDetailsByMulDartaaNumber(options.id)
      }
    }
  };

  const getDetailsByMulDartaaNumber = (id) => {
    if (id) {
      AHMIS.get(API_URL.mulDartaaDetailsFromId + "/" + id)
        .then(response => {
          let jsondata = response.data;
          if (jsondata.type === SUCCESS) {
            setMulDartaaNumberDefaultValues(response.data);
          }
        })
        .catch(error => {
          AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
        });
    }
  }

  const getDartaaNumber = () => {
    let url = `${API_URL.getLatestDartaaNumber + "?fiscalYear="}` + DateUtils.getCurrentFiscalYear();
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setValue("mulDartaaNumber", jsondata?.data)
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const getGaunOrTole = () => {
    let url = `${API_URL.mulDartaaRegister}/gaunOrTole`
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type == SUCCESS) {
          const gaunTole = jsondata.objectList.map((item) => ({ label: item, value: item }))
          setGaunOrTole(gaunTole);
        } else {
          setGaunOrTole([])
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const handleChecked = (e) => {
    setValue("otherCountry", e.target?.checked);
  };

  useEffect(() => {
    !palikaInfo && dispatch(getHealthClientAndPalikaInfoData());
  }, [palikaInfo])

  return (
    <>
      <RegisterHeader
        registerTitle="मूल दर्ता रजिस्टर"
        handleModalOpen={openMulDartaaModal}
        getRegisterData={getMulDartaaData}
        onHeaderParamChange={onHeaderParamChange}
        // hideButton={!Permissions?.includes(ROLE_AHMIS_MULDARTAAREGISTER_SAVE)}
        fromDateDefaultFormat
        lazyLoading
        showSearchField
      />
      <CustomModal
        title={modalTitle}
        showModal={showMulDartaaModal}
        onModalSubmit={handleSubmit(submitMulDartaaForm)}
        onModalClose={closeMulDartaaModal}
        maxWidth="lg"
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <Box>
              <NepaliCalender
                id="mul-dartaa-dartaa-miti"
                name="dartaaMiti"
                label="दर्ता मिति"
                showDefaultDate
                onChange={handleDateChange}
                defaultDate={modalDefaultValues?.dartaaMiti}
              />
              {errors?.dartaaMiti && errors.dartaaMiti?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="सेवाग्राहीको किसिम"
              name="patientType"
              options={PATIENT_TYPES}
              onChange={handleCustomReactSelectChange}
              defaultValue={modalDefaultValues?.patientType}
            />
            {errors?.patientType && errors.patientType?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          {watchFields && watchFields.includes("PREVIOUS_PATIENT") ? (
            <Grid item xs={12} sm={6} md={3}>
              <CustomReactSelect
                label="दर्ता नम्बर"
                name="mulDartaaNumber"
                options={mulDartaaOptions}
                defaultValue={modalDefaultValues?.mulDartaaNumber}
                onChange={handleDartaaNumberChange}
              />
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="दर्ता नम्बर"
                type="number"
                size="small"
                variant="outlined"
                name="mulDartaaNumber"
                autoComplete="true"
                fullWidth
                InputLabelProps={{ shrink: true }}
                defaultValue={modalDefaultValues?.mulDartaaNumber}
                {...register('mulDartaaNumber', { required: true })}
              />
              {errors?.mulDartaaNumber && errors.mulDartaaNumber?.type === 'required' && <span className="error-message">{REQUIRED_FIELD}</span>}
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="सेवाग्राहीको नाम"
              type="text"
              size="small"
              variant="outlined"
              name="patientFirstName"
              autoComplete="on"
              tabIndex={1}
              autoFocus={!modalDefaultValues?.id}
              fullWidth
              InputLabelProps={{ shrink: true }}
              defaultValue={modalDefaultValues && modalDefaultValues?.patientFirstName}
              {...register("patientFirstName", { required: true })}
            />
            {errors?.patientFirstName && errors.patientFirstName?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="सेवाग्राहीको थर"
              type="text"
              size="small"
              variant="outlined"
              name="patientLastName"
              autoComplete="on"
              fullWidth
              InputLabelProps={{ shrink: true }}
              defaultValue={modalDefaultValues?.patientLastName}
              {...register("patientLastName", { required: true })}
            />
            {errors?.patientLastName && errors.patientLastName?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="लिङ्ग"
              name="gender"
              size="small"
              fullWidth
              options={GENDER_OPTIONS}
              defaultValue={modalDefaultValues?.gender}
              onChange={handleCustomReactSelectChange}
            />
            {errors?.gender && errors.gender?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          {/* <Grid item xs={12} sm={6} md={3}>
            <Box>
              <NepaliCalender
                id="date-of-birth-of-child"
                label="जन्म मिति"
                name="dateOfBirth"
                defaultDate={modalDefaultValues?.dateOfBirth}
                onChange={handleDateChange}
              />
            </Box>
            {errors?.dateOfBirth && errors.dateOfBirth?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid> */}
          <Grid item xs={12} sm={6} md={3}>
            <InputGroupComponent
              textFieldLabel="उमेर"
              textFieldType="number"
              inputProps={{ min: 0 }}
              menuItems={AGE_UNITS}
              textFieldValue={watchFields[4]}
              selectFieldValue={watchFields[5]}
              onChange={handleCustomReactSelectChange}
              textFieldName="age"
              selectFieldName="ageUnit"
            />
            {errors.age && errors.age.type === "min" && (<span className="error-message">{GREATER_THAN_ZERO}</span>)}
            {errors.age && errors.age.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3} id="casteScrollContainer" style={{ overflowY: 'auto' }}>
            <CustomReactSelect
              label="जाती कोड"
              size="small"
              name="casteCode"
              options={CASTE_CODES}
              onChange={handleCustomReactSelectChange}
              defaultValue={modalDefaultValues?.casteCode}
            />
            {errors?.casteCode && errors.casteCode?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="जिल्ला"
              name="district"
              variant="outlined"
              onChange={handleDistrictChange}
              options={districtOptions}
              defaultValue={districtName}
            />
            {errors?.district && errors.district?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="नगर/गाउँपालिका"
              name="palikaName"
              variant="outlined"
              options={palikaOptions}
              onChange={handlePalikaNameChange}
              defaultValue={palikaName}
            />
            {errors?.palikaName && errors.palikaName?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="वडा नं"
              type="number"
              size="small"
              variant="outlined"
              name="wardNumber"
              autoComplete="true"
              fullWidth
              InputLabelProps={{ shrink: true }}
              defaultValue={modalDefaultValues?.wardNumber}
              {...register("wardNumber", { required: true })}
              onChange={(e) => {
                register("wardNumber").onChange(e);
              }}
            />
            {errors?.wardNumber && errors.wardNumber?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              name="gaunOrTole"
              label="गाँउ/टोल"
              variant="outlined"
              options={gaunOrTole}
              onChange={handleCustomReactSelectChange}
              defaultValue={modalDefaultValues?.gaunOrTole}
              creatable
            />
            {errors?.gaunOrTole && errors.gaunOrTole?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              name="nid"
              label="राष्ट्रिय परिचयपत्र नम्वर"
              variant="outlined"
              autoComplete="on"
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              defaultValue={modalDefaultValues?.nid}
              {...register("nid")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="सम्पर्क नम्बर"
              size="small"
              variant="outlined"
              name="phoneNumber"
              autoComplete="true"
              fullWidth
              InputLabelProps={{ shrink: true }}
              defaultValue={modalDefaultValues?.phoneNumber}
              {...register("phoneNumber")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} id="scrollContainer" style={{ overflowY: 'auto' }}>
            <CustomReactSelect
              label="सेवाको किसिम"
              name="sewaType"
              variant="outlined"
              options={MUL_DARTA_SEWA_TYPES}
              isMulti
              defaultValue={modalDefaultValues?.sewaType}
              onChange={handleCustomReactSelectChange}
            />
            {errors?.sewaType && errors.sewaType?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          {Array.isArray(watchFields[3]) && watchFields[3].includes("13") && (
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="अन्य सेवाको किसिम"
                size="small"
                variant="outlined"
                name="otherSewaType"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.otherSewaType}
                {...register("otherSewaType")}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="नि:शुल्क/शुल्क रु"
              type="text"
              size="small"
              variant="outlined"
              name="cost"
              autoComplete="true"
              fullWidth
              InputLabelProps={{ shrink: true }}
              defaultValue={modalDefaultValues?.cost}
              {...register("cost")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="प्रेषण भई आएको संस्थाको नाम"
              type="text"
              size="small"
              variant="outlined"
              name="referredIn"
              autoComplete="true"
              fullWidth
              InputLabelProps={{ shrink: true }}
              defaultValue={modalDefaultValues?.referredIn}
              {...register("referredIn")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} >
            <Tooltip title="यदि अन्य मुलुक भए मात्र यो कोठामा चिन्ह लगाउनुहोस ।" placement="top" arrow>
              <Controller
                name="otherCountry"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="अन्य मुलुक"
                    control={
                      <Checkbox {...field} checked={field.value} color="primary" />
                    }
                  />
                )}
              />
            </Tooltip>
          </Grid>
        </Grid>
      </CustomModal>
      <DeleteRegisterRecordConformation
        showDeleteModal={showMulDartaaDeleteModal}
        closeDeleteModel={closeMulDartaaDeleteModal}
        deleteRecord={deleteMulDartaaRow}
      />
      <MulDartaaRegister
        onEditRow={mulDartaaEdit}
        tableData={mulDartaaTableData}
        deleteRow={onDeleteMulDartaaRow}
        totalSize={totalSize}
      />
    </>
  )
}

export default MulDartaa;